<script setup>
import { Link } from '@inertiajs/vue3';

defineProps({
    brand: {
        type: Object,
        default: () => ({})
    }
});

// Compute the full image URL using relative path
const getLogoUrl = (logo) => {
    if (!logo) return null;
    return `/brand-images/${logo}`;
}
</script>

<template>
    <div class="brand-display">
        <Link v-if="brand && brand.id" :href="`/brands/${brand.id}`">
            <img v-if="brand.logo" 
                :src="getLogoUrl(brand.logo)" 
                :alt="brand.name" 
                :title="brand.name"
                class="brand-logo" />
            <span v-else class="brand-name">{{ brand.name }}</span>
        </Link>
        <div v-else-if="brand">
            <img v-if="brand.logo" 
                :src="getLogoUrl(brand.logo)" 
                :alt="brand.name" 
                :title="brand.name"
                class="brand-logo" />
            <span v-else class="brand-name">{{ brand.name }}</span>
        </div>
    </div>
</template>

<style scoped>
.brand-display {
    margin: 5px 0;
}

.brand-logo {
    max-height: 20px;
    max-width: 80px;
    object-fit: contain;
}

.brand-name {
    font-size: 0.85rem;
    font-weight: 600;
    color: #555;
    background-color: #f5f5f5;
    padding: 2px 6px;
    border-radius: 3px;
    display: inline-block;
}
</style>
